import React, { Component, Fragment } from 'react';
import FormMultiSelect, { SearchableSelect } from '../../../_shared/forms/FormMultiSelect';
import JobExtras from '../../JobExtras';

export default class Skip extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormMultiSelect
                            label="Waste Volume Removed"
                            options={this.props.skipOptions}
                            handleMultiSelectChange={(value) => this.props.handleMultiSelectChange(value, 'skips')}
                            classes="form-control"
                            prefixes={this.props.skips}
                        />
                    </div>
                </div>
            
            </Fragment>
        );
    }
}
